import { useAuth } from '@/composables/auth'
import { apiPost } from '@/composables/useApi'

// 播放器开关（跟读、发音评分）默认打开；用户手动关掉后记住，之后打开素材都保持关闭，直到再手动打开。
// 登录用户存在账号里换设备也生效，本机再存一份给未登录和账号数据还没到的时候用。
// 本机记录按账号分开存，同一台电脑上换新号不会沿用别的账号关掉的设置。
const storageKey = (key, uid) => `${key}:${uid || 'guest'}`

function isPreferenceOn(key) {
  const { user, userData } = useAuth()
  const remote = userData.value?.playerPreferences?.[key]
  if (typeof remote === 'boolean') return remote
  return window.localStorage.getItem(storageKey(key, user.value?.uid)) !== 'false'
}

async function savePreference(key, enabled) {
  const { user } = useAuth()
  window.localStorage.setItem(storageKey(key, user.value?.uid), String(enabled))
  if (!user.value) return
  await apiPost('/api/users/player-preferences', { [key]: enabled })
}

export const isReadAlongPreferred = () => isPreferenceOn('readAlongEnabled')
export const saveReadAlongPreference = (enabled) => savePreference('readAlongEnabled', enabled)
export const isAssessmentPreferred = () => isPreferenceOn('assessmentEnabled')
export const saveAssessmentPreference = (enabled) => savePreference('assessmentEnabled', enabled)
